import { CaResult } from '../../core';
import { currentState } from '../state';

export function setCaResult(value: CaResult): void {
    const state = currentState();

    value?.groups?.forEach((g) => {
        g.areas?.forEach((a) => {
            a.collapsedProTips = false;
        });
        g.first = g.areas?.[0];
        g.last = g.areas?.[g.areas.length - 1];
    });
    state.caResult = value;
}
